module.exports = __webpack_public_path__ + "img/paper-plane.a29ddeeb.svg";